import { Link } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Grid,
} from '@mui/material';
import {
  Person as AgentIcon,
  Business as ClientIcon,
  Inventory as ShipperIcon,
  LocalShipping as ConsignatarioIcon,
  Description as GuiasIcon,
} from '@mui/icons-material';

const OficinaIndex = () => {
  const modules = [
    {
      title: 'Agentes',
      description: 'Gestión de agentes de carga',
      link: '/oficina/agentes',
      icon: AgentIcon,
      gradient: 'linear-gradient(135deg, #1976D2 0%, #1565C0 100%)',
    },
    {
      title: 'Clientes',
      description: 'Gestión de clientes',
      link: '/oficina/clientes',
      icon: ClientIcon,
      gradient: 'linear-gradient(135deg, #388E3C 0%, #2E7D32 100%)',
    },
    {
      title: 'Shippers',
      description: 'Gestión de remitentes',
      link: '/oficina/shippers',
      icon: ShipperIcon,
      gradient: 'linear-gradient(135deg, #7B1FA2 0%, #6A1B9A 100%)',
    },
    {
      title: 'Consignatarios',
      description: 'Gestión de consignatarios (CNEE)',
      link: '/oficina/consignatarios',
      icon: ConsignatarioIcon,
      gradient: 'linear-gradient(135deg, #F57C00 0%, #E65100 100%)',
    },
    {
      title: 'Banco de Guías',
      description: 'Gestión de guías aéreas',
      link: '/oficina/guias',
      icon: GuiasIcon,
      gradient: 'linear-gradient(135deg, #0097A7 0%, #00838F 100%)',
    },
  ];

  return (
    <Box>
      {/* Header */}
      <Card
        sx={{
          mb: 4,
          background: 'linear-gradient(135deg, #3F51B5 0%, #303F9F 100%)',
          color: 'white',
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Oficina - Administración
          </Typography>
          <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
            Gestión de agentes, clientes, shippers y consignatarios
          </Typography>
        </CardContent>
      </Card>

      {/* Modules Grid */}
      <Grid container spacing={3}>
        {modules.map((module) => {
          const IconComponent = module.icon;
          return (
            <Grid item xs={12} sm={6} lg={4} key={module.title}>
              <Card
                sx={{
                  height: '100%',
                  transition: 'all 0.3s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 6,
                  },
                }}
              >
                <CardActionArea
                  component={Link}
                  to={module.link}
                  sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
                >
                  <Box
                    sx={{
                      background: module.gradient,
                      p: 3,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <IconComponent sx={{ fontSize: 48, color: 'white' }} />
                  </Box>
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      {module.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {module.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default OficinaIndex;

